import React, { Component } from 'react';
import { Formik, Form, FieldArray } from 'formik';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import { updateFormData, setListing, updateListing } from '../actions';
import { populateListingFromFormData } from '../helpers';

import ModalComponent from '../../../ui/Modal';
import AddOnModal from '../components/AddOnModal';
import { ListingFormDescriptionBottomBar } from './listingFormDescriptions';

const mapStateToProps = state => ({
  listing: state.Listing,
  global: state.Global
});

class ListingFormAddOns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      deleteIndex: null,
      modalOpen: false,
      addOnModalOpen: false,
      editingAddOn: null,
      showExpiredAddons: false
    }
    const workflow = this.props.workflow ? this.props.workflow : 'forms';
    this.nextPage = `/${this.props.parent}/listing/${workflow}/calendars`;
    this.prevPage = `/${this.props.parent}/listing/${workflow}/pricing`;

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(index) { this.setState({ modalOpen: true, deleteIndex: index }); }
  closeModal() { this.setState({ modalOpen: false }); }

  openAddOnModal = (addOn) => {
    if (!addOn)
      addOn = null;
    this.setState({ addOnModalOpen: true, editingAddOn: addOn })
  }
  closeAddOnModal = () => { this.setState({ addOnModalOpen: false, editingAddOn: null }) }

  cloneAddOn = (addOn, clearDates) => {
    let clonedAddOn = Object.assign({}, addOn);
    clonedAddOn._id = null;
    if (clearDates) clonedAddOn.validDates = [];
    else clonedAddOn.validDates = clonedAddOn.validDates.map(vd => Object.assign({}, vd));
    this.openAddOnModal(clonedAddOn);
  }

  submitAddOn = (addOn, formValues) => {
    if (addOn._id) {
      let addOnIndex = formValues.addOns.findIndex(a => a._id === addOn._id);
      if (addOnIndex > -1) formValues.addOns.splice(addOnIndex, 1, addOn);
    } else {
      addOn._id = `a${addOn.name}i${formValues.addOns.length + 1}`;
      formValues.addOns.push(addOn);
    }
    this.props.dispatch(updateFormData(formValues));
    this.closeAddOnModal();
  }

  saveListing = (values, pathAfterSave) => {
    this.setState({ isSubmitting: true });
    let { dispatch, listing, step, history, workflow } = this.props;
    if (values.lastCompleted < step) { values.lastCompleted = step; }

    setTimeout(() => {
      let defaultObj = { name: '', description: '', price: 0 };
      values.addOns = values.addOns.filter((a) => {
        return a.name !== defaultObj.name && a.description !== defaultObj.description;
      });

      dispatch(updateFormData(values));
      let updatedData = populateListingFromFormData(values);
      if (!updatedData._id) { updatedData._id = listing.listingData._id; }
      dispatch(setListing(updatedData));
      dispatch(updateListing()).then(() => {
        if (workflow === 'edit') history.goBack();
        else history.push(pathAfterSave);
      })
    }, 1000);
  }

  onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false);
    this.saveListing(values, this.nextPage);
  }

  submitAndBack = (values) => {
    this.saveListing(values, this.prevPage);
  }

  submitAndExit = (values) => {
    this.saveListing(values, `/${this.props.parent}/manage-listings`);
  }

  exit = (values, { setSubmitting }) => {
    this.setState({ isSubmitting: true });
    let { dispatch, history } = this.props;
    let defaultObj = { name: '', description: '', price: 0 };
    values.addOns = values.addOns.filter((a) => {
      return a.name !== defaultObj.name && a.description !== defaultObj.description;
    });
    let updatedData = populateListingFromFormData(values);
    setTimeout(() => {
      dispatch(setListing(updatedData));
      dispatch(updateListing());
      history.push(`/${this.props.parent}/manage-listings?view=ma`);
      setSubmitting(false);
    }, 1000)
  }

  renderBody() {
    return (<div>
      <div className="col-12">
        Are you sure you want to permanently delete this add-on?
      </div>
    </div>)
  }

  renderButtonRow(addOn, values) {
    return (
      <div className="w-100 row align-items-center m-0">
        <div className="col text-center pl-0">
          <label onClick={() => this.closeModal()}>Cancel</label>
        </div>
        <div className="col text=center">
          <button className='btn btn-primary' onClick={(e) => {
            e.preventDefault();
            this.deleteAddOn(addOn, values)
          }}>Delete</button>
        </div>
      </div>
    )
  }

  deleteAddOn(addOn, values) {
    let { dispatch } = this.props;
    let test = values.addOns.filter(x => x._id === addOn._id)[0];
    test.isActive = false;
    dispatch(updateFormData(values));
  }

  toggleExpiredAddOns = () => {
    this.setState({ showExpiredAddons: !this.state.showExpiredAddons })
  }

  renderReadonly(index, values, addOn, disabled) {
    let validDates = '';

    addOn.validDates.forEach((obj, i) => {
      let startDate = moment(obj.startDate).format('MM/DD/YYYY');

      validDates = `${validDates}${startDate}`;

      if (obj.endDate !== null) {
        let endDate = moment(obj.endDate).format('MM/DD/YYYY');
        validDates = `${validDates} - ${endDate}`;
      }

      validDates = `${validDates}, `
    });
    validDates = validDates.replace(/,\s*$/, "");
    if (!validDates) validDates = "N/A";
    return (
      <div key={`addon-readonly-${index}`} className={!disabled ? "add-on-container" : "add-on-container disabled"}>
        <h6>
          <div className="col-12">
            {addOn.name}
            {!disabled ?
              <i className="fas fa-times" onClick={() => {
                this.openModal(index);
              }}></i>
              : null}
          </div>
        </h6>
        <div className="row">
          <div className="col-12 col-md-8">
            <div className="fieldgroup row description">
              <div className="col-12">
                {addOn.description}
              </div>
            </div>
            <div className="fieldgroup row price">
              <div className="col-12">
                <b>${addOn.price}</b>
              </div>
            </div>
            <div className="fieldgroup row inventory">
              <div className="col-12">
                <b>Inventory:</b>&nbsp;<span>{!addOn.totalInventory ? "N/A" : addOn.inventory}</span>
              </div>
            </div>
            <div className="fieldgroup row valid-dates last">
              <div className="date-div">
                <b>Valid Dates:</b>&nbsp;<span>{validDates}</span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 button-container">
            <div>{!disabled
              ? (<span className="duplicate-link" onClick={() => { this.cloneAddOn(addOn); }}>
                <i className="fa fa-clone duplicate-link-icon"></i>&nbsp;&nbsp;Duplicate AddOn</span>)
              : (<span className="duplicate-link" onClick={() => { this.cloneAddOn(addOn, true); }}>
                <i className="fa fa-history duplicate-link-icon"></i>&nbsp;&nbsp;Restore AddOn</span>)
            }</div>
            {!disabled && <div><button className="btn-secondary mx-auto mt-2" onClick={(e) => {
              e.preventDefault();
              this.openAddOnModal(addOn)
            }}>Edit</button></div>}
          </div>
        </div>
        {this.state.modalOpen && this.state.deleteIndex === index && (<ModalComponent
          id="ConfirmationModal"
          title="Delete Add-On"
          noMinHeight={true}
          body={this.renderBody()}
          footer={this.renderButtonRow(addOn, values)}
          onClose={this.closeModal} />)}
      </div>
    )
  }

  renderAddOns = (values) => {
    if (!values.addOns.length)
      return null;

    return values.addOns.map((addOn, index) => {
      let isExpired = true;
      let dateInRange = addOn.validDates.find(vd => moment(vd.startDate).isSameOrAfter(moment(), 'd') ||
        (vd.endDate && moment(vd.endDate).isSameOrAfter(moment(), 'd')));
      //If addOn is active, has no dates associated, or has dates and dates are in the future then valid.
      if (addOn.isActive && (addOn.validDates.length === 0 || dateInRange)) isExpired = false;
      //However if there is no inventory left, then expired.
      if (addOn.totalInventory > 0 && addOn.inventory <= 0) isExpired = true;
      if (isExpired) return null;
      return this.renderReadonly(index, values, addOn, false);
    })
  }

  renderExpiredAddons = (values) => {
    if (!this.state.showExpiredAddons)
      return null;

    return values.addOns.map((addOn, index) => {
      let isExpired = true;
      let dateInRange = addOn.validDates.find(vd => moment(vd.startDate).isSameOrAfter(moment(), 'd') ||
        (vd.endDate && moment(vd.endDate).isSameOrAfter(moment(), 'd')));
      //If addOn is active, has no dates associated, or has dates and dates are in the future then valid.
      if (!addOn.isActive || addOn.validDates.length === 0 || dateInRange) isExpired = false;
      //However if there is no inventory left, then expired.
      if (addOn.totalInventory > 0 && addOn.inventory <= 0) isExpired = true;
      if (!isExpired) return null;
      return (<div key={`readonly-${addOn._id}`}>
        <hr className="horizontal-line" />
        {this.renderReadonly(index, values, addOn, true)}
      </div>);
    })
  }

  render() {
    let { addOnModalOpen, editingAddOn } = this.state;
    let initValues = this.props.listing.formData;

    const submitText = this.props.exit ? 'Save' : 'Next';

    return (<div>
      <Formik onSubmit={this.props.exit ? this.exit : this.onSubmit} initialValues={initValues}>
        {({ values, errors, touched, setFieldValue, submitForm }) => (
          <Form>
            <div>
              <div>
                <h2>Manage Add-Ons</h2>
                <div>
                  You can include additional items or services for purchase with your rental
                  property. Things like game tickets, meal vouchers, and transportation
                  are great enhancements to the rental experience.
                </div>
              </div>
              <FieldArray name="addOns" render={(arrayHelpers) => (
                <div className="add-ons">
                  <h5>
                    Current Add-Ons
                  </h5>
                  {this.renderAddOns(values)}
                  <div className="row">
                    <div className="col-12">
                      <label className="create-addon-link" onClick={(e) => {
                        this.openAddOnModal();
                      }}>+ Create another Add-On</label>
                    </div>
                  </div>
                  {this.props.workflow === 'edit' && (
                    <div className="expired-addons">
                      <div className="row">
                        <div className="col-12">
                          <div className="row" onClick={() => this.toggleExpiredAddOns()}>
                            <div className="col-6">
                              <h5 className="expired-text">Expired Add-Ons</h5>
                            </div>
                            <div className="col-6">
                              <i className={`fa ${!this.state.showExpiredAddons ? "fa-angle-right" : "fa-angle-down"} expired-arrow`}></i>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-12">
                              {/* only expired if all dates are expired */}
                              {this.renderExpiredAddons(values)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>)
                  }
                </div>
              )} />
            </div>
            <ListingFormDescriptionBottomBar
              isSubmitting={this.state.isSubmitting}
              submitAndBack={this.submitAndBack}
              submitAndExit={this.submitAndExit}
              submitText={submitText}
              values={values}
              workflow={this.props.workflow}
            />
          </Form>
        )}

      </Formik>
      {addOnModalOpen && (<AddOnModal onClose={this.closeAddOnModal} onSubmit={(addOnValues) => { this.submitAddOn(addOnValues, initValues) }} addOn={editingAddOn} />)}
    </div>)
  }
}

export default withRouter(connect(mapStateToProps)(ListingFormAddOns));
